var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action } from 'mobx';
import { api } from 'helpers/Api';
import { Article } from './Model';
export default class default_1 {
    constructor() {
        this.articles = [];
        this.loaded = false;
        this.set = (articles) => {
            this.articles = articles.map(article => new Article(article));
            this.loaded = true;
        };
        this.push = (article) => {
            this.articles.push(new Article(article));
        };
        this.replace = (article) => {
            this.articles.splice(this.articles.findIndex(f => f.id === article.id), 1, article);
        };
        this.pull = (article) => {
            this.articles.splice(this.articles.findIndex(a => a.id === article.id), 1);
        };
    }
    read(id) {
        if (id)
            return api.get(`article/${id}`).then(article => new Article(article));
        return api.get('article').then(this.set);
    }
    create(article) {
        return api.post('article', article).then(this.push);
    }
    update(id, article) {
        return api.put('article/' + id, article).then(this.replace);
    }
    disable(id, disabled) {
        return api.patch('article/' + id, { disabled }).then(this.pull);
    }
}
__decorate([
    observable
], default_1.prototype, "articles", void 0);
__decorate([
    observable
], default_1.prototype, "loaded", void 0);
__decorate([
    action
], default_1.prototype, "set", void 0);
__decorate([
    action
], default_1.prototype, "push", void 0);
__decorate([
    action
], default_1.prototype, "replace", void 0);
__decorate([
    action
], default_1.prototype, "pull", void 0);



//////////////////
// WEBPACK FOOTER
// ./src/modules/Articles/Store.ts
// module id = 309
// module chunks = 0